module.exports = __webpack_public_path__ + "media/images/logo-white-03ac5e5d.svg";